module.exports = __webpack_public_path__ + "img/translation_how_it_works.6ad4a1ee.svg";